import { Box, Typography } from "@mui/material"
import { PayloadTask } from "routes/regime/components/payload-task"
import { ContentOverrideField } from "routes/regime/components/content-override-field"

// Replaces the task notes editing area for collaboration clients: the master task note becomes
// directly editable inline (writing to the payload task note override) in place of the read-only
// display and the "Add notes" prepend button.
export function InlineTaskNoteOverride() {
    return (
        <PayloadTask>
            <Box sx={{ mt: 2 }}>
                <Typography component="div" variant="overline" gutterBottom>
                    Notes
                </Typography>
                <ContentOverrideField field="noteOverride" sourcePath="note" label="Task notes" />
            </Box>
        </PayloadTask>
    )
}
